import React, { PureComponent } from "react"
import { StaticQuery, graphql } from "gatsby"
import { ArrowRight, Folder } from "react-feather"
import get from "lodash/get"

import { ButtonLink, ExternalButtonLink } from "../../components/Button"
import Box from "../../components/Box"
import Grid from "../../components/Grid"
import Screen from "../../components/Screen"
import Subheading from "../../components/Subheading"
import Text from "../../components/Text"
import Wrapper from "../../components/Wrapper"

class FeaturedProject extends PureComponent {
	render() {
		const screens = {
			desktop: get(
				this,
				"props.data.featuredDesktopScreen.childImageSharp.fluid"
			),
			mobile: get(
				this,
				"props.data.featuredMobileScreen.childImageSharp.fluid"
			),
		}

		return (
			<section>
				<Box bg="dark.0">
					<Wrapper pt={5} textAlign="center">
						<Subheading mt={0} mb={2}>
							Featured Project
						</Subheading>
						<Text
							color="contrast.4"
							fontSize={4}
							fontWeight="bold"
							lineHeight={1}
						>
							NaviSavi
						</Text>
						<Text
							color="contrast.3"
							fontSize={2}
							lineHeight={1}
							mt={1}
							mx="auto"
							maxWidth="20em"
						>
							Development, project management and architecture of a video-only platform for travellers, digital nomads and online wanderlust fans.
						</Text>
						<Box my={3} textAlign="center">
							<ButtonLink
								m="0.25em"
								minWidth="10.25em"
								to="/projects/navisavi"
								rel="nofollow"
								inverted
								secondary
							>
								<Folder />
								Read article
							</ButtonLink>
							<ButtonLink
								m="0.25em"
								minWidth="10.25em"
								to="/projects/navisavi"
								secondary
							>
								<ArrowRight />
								View project
							</ButtonLink>
						</Box>
						<Box mt={4}>
							<Screen screens={screens} />
						</Box>
					</Wrapper>
				</Box>
				<Box
					boxShadow="0 -1px 3px rgba(0, 0, 0, 0.025)"
					bg="base"
					position="relative"
				>
					<Wrapper>
						<Grid py={[4, 4, 5]} gap="1em 2em" width={320}>
							<Text color="contrast.4" maxWidth="20em" mx="auto">
								We were involved in every stage of NaviSavi's development, helping take it from zero users to a platform home to tens of thousands of authentic travel videos.
							</Text>
							<Text color="contrast.4" maxWidth="20em" mx="auto">
								Leaning heavily on our past experience with startups, we managed to deliver a product which went on to attract significant interest from investors.
							</Text>
						</Grid>
					</Wrapper>
				</Box>
			</section>
		)
	}
}

export default () => (
	<StaticQuery
		query={graphql`
			query FeaturedProjectQuery {
				featuredDesktopScreen: file(
					relativePath: { eq: "img/featured/ns-desktop.png" }
				) {
					childImageSharp {
						fluid {
							...GatsbyImageSharpFluid_withWebp
						}
					}
				}
				featuredMobileScreen: file(
					relativePath: { eq: "img/featured/ns-mobile.png" }
				) {
					childImageSharp {
						fluid {
							...GatsbyImageSharpFluid_withWebp
						}
					}
				}
			}
		`}
		render={data => <FeaturedProject data={data} />}
	/>
)
